import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./messageBox.html";
import { selectSharedLabels, WireI18n } from '~/modules/stores/i18nStore';
import { NotificationType } from '~/modules/stores/notificationStore';
import { getUniqueIteratorKey } from '~/modules/utilities/lwcUtilities';
class MessageBox extends LightningElement {
  constructor(...args) {
    super(...args);
    this.iteratorKey = getUniqueIteratorKey();
    this.message = '';
    this.type = NotificationType.Success;
    this.hideCloseButton = false;
    this.title = '';
    this.labels = void 0;
    this.focusCloseButton = () => {
      const notificationContainer = this.template.querySelector('div[role="alertdialog"]');
      const closeButton = notificationContainer?.querySelector('.close-button');
      const button = closeButton?.querySelector('button');
      button?.focus();
    };
    this.handleClose = () => {
      const buttonClosedEvent = new CustomEvent('close', {
        detail: {
          iteratorKey: this.iteratorKey
        }
      });
      this.dispatchEvent(buttonClosedEvent);
    };
  }
  renderedCallback() {
    this.focusCloseButton();
  }
  get iconProperties() {
    return this.type === 'success' ? {
      icon: 'check',
      theme: 'green',
      iconDescription: this.labels.success
    } : {
      icon: 'error',
      theme: 'red',
      iconDescription: this.labels.error
    };
  }
  get cssNotificationClass() {
    return 'notification-container ' + this.type;
  }
  get closeButtonAriaLabel() {
    return this.labels?.close;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MessageBox, {
  publicProps: {
    iteratorKey: {
      config: 0
    },
    message: {
      config: 0
    },
    type: {
      config: 0
    },
    hideCloseButton: {
      config: 0
    },
    title: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSharedLabels
        };
      }
    }
  },
  fields: ["focusCloseButton", "handleClose"]
});
const __lwc_component_class_internal = _registerComponent(MessageBox, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;